export const claritySet = (key: string, value?: string) => {
  if (window.clarity && value) {
    window.clarity?.('set', key, value)
  }
}

export const clarityIdentify = (userId: string) => {
  if (userId) {
    window.clarity?.('identify', userId)
  }
}

export const clarityEvent = (name: string) => {
  if (name) {
    window.clarity?.('event', name)
  }
}
